const wnbaEventId = 12238;
const wnbaBetTypeIds = [1065439988, 1065319217, 1062009163, 1065319218];

export const allWNBAQuery = {
  bool: {
    must_not: [
      {
        bool: {
          must: [
            {
              term: {
                eventId: wnbaEventId,
              },
            },
            {
              terms: {
                betTypeId: wnbaBetTypeIds,
              },
            },
          ],
        },
      },
    ],
  },
};
